import { render, staticRenderFns } from "./ColumnPreview.vue?vue&type=template&id=962738a4&"
import script from "./ColumnPreview.vue?vue&type=script&lang=js&"
export * from "./ColumnPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports